import { ReactNode } from 'react'
import { Typography, useTheme } from '@mui/material'

import { useStyles } from './styles'

interface IProps {
  primary: string
  secondary?: ReactNode | string | null
  secondarySx?: object
  primaryAccent?: boolean
  withHashSymbol?: boolean
  hideText?: boolean
}

export const TextCell = ({
  primary,
  secondary,
  secondarySx,
  primaryAccent,
  withHashSymbol,
  hideText,
}: IProps) => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <div style={{ visibility: hideText ? 'hidden' : 'visible' }}>
      <Typography
        className={`${classes.tableBodyCell} ${primaryAccent ? classes.tableBodyCellBold : ''}`}
      >
        {primary}
      </Typography>
      {secondary && (
        <Typography
          // className={classes.tableBodyCell}
          sx={{ fontSize: 11, color: theme.palette.custom.darkBlue2, ...secondarySx }}
        >
          {withHashSymbol ? `#${secondary}` : secondary}
        </Typography>
      )}
    </div>
  )
}
